import { render } from "./DynamicBlogDetails.vue?vue&type=template&id=46b5b1ee"
import script from "./DynamicBlogDetails.vue?vue&type=script&lang=js"
export * from "./DynamicBlogDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__